Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BRAND_LUXURY = exports.BRAND_SELECT = exports.BRAND_DEFAULT = exports.requiredBrandPropType = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BrandProvider = require('./BrandProvider');

Object.defineProperty(exports, 'BRAND_DEFAULT', {
  enumerable: true,
  get: function () {
    function get() {
      return _BrandProvider.BRAND_DEFAULT;
    }

    return get;
  }()
});
Object.defineProperty(exports, 'BRAND_SELECT', {
  enumerable: true,
  get: function () {
    function get() {
      return _BrandProvider.BRAND_SELECT;
    }

    return get;
  }()
});
Object.defineProperty(exports, 'BRAND_LUXURY', {
  enumerable: true,
  get: function () {
    function get() {
      return _BrandProvider.BRAND_LUXURY;
    }

    return get;
  }()
});
exports['default'] = withBrand;

var _airbnbPropTypes = require('airbnb-prop-types');

var _getComponentName = require('airbnb-prop-types/build/helpers/getComponentName');

var _getComponentName2 = _interopRequireDefault(_getComponentName);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _hoistNonReactStatics = require('hoist-non-react-statics');

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _brcast = require('../shapes/brcast');

var _brcast2 = _interopRequireDefault(_brcast);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var contextTypes = _defineProperty({}, _BrandProvider.BRAND_CONTEXT_KEY, _brcast2['default']);

var requiredBrandPropType = _BrandProvider.BrandPropType.isRequired;
requiredBrandPropType.isRequired = requiredBrandPropType;
exports.requiredBrandPropType = requiredBrandPropType;
function withBrand(WrappedComponent) {
  var WithBrand = function (_React$PureComponent) {
    _inherits(WithBrand, _React$PureComponent);

    function WithBrand(props, context) {
      _classCallCheck(this, WithBrand);

      var _this = _possibleConstructorReturn(this, (WithBrand.__proto__ || Object.getPrototypeOf(WithBrand)).call(this, props, context));

      var broadcast = context[_BrandProvider.BRAND_CONTEXT_KEY];
      var brand = broadcast ? broadcast.getState() : _BrandProvider.BRAND_DEFAULT;

      _this.state = { brand: brand };
      return _this;
    }

    _createClass(WithBrand, [{
      key: 'componentDidMount',
      value: function () {
        function componentDidMount() {
          var _this2 = this;

          var broadcast = this.context[_BrandProvider.BRAND_CONTEXT_KEY];

          if (broadcast) {
            // subscribe to future loading changes
            this.unsubscribe = broadcast.subscribe(function (brand) {
              _this2.setState({ brand: brand });
            });
          } else {
            this.setState({ brand: _BrandProvider.BRAND_DEFAULT });
          }
        }

        return componentDidMount;
      }()
    }, {
      key: 'componentWillUnmount',
      value: function () {
        function componentWillUnmount() {
          if (this.unsubscribe) {
            this.unsubscribe();
          }
        }

        return componentWillUnmount;
      }()
    }, {
      key: 'render',
      value: function () {
        function render() {
          var brand = this.state.brand;

          return _react2['default'].createElement(WrappedComponent, _extends({}, this.props, {
            brand: brand
          }));
        }

        return render;
      }()
    }]);

    return WithBrand;
  }(_react2['default'].PureComponent);

  WithBrand.WrappedComponent = WrappedComponent;
  WithBrand.contextTypes = contextTypes;

  // eslint-disable-next-line react/forbid-foreign-prop-types
  if (WrappedComponent.propTypes) {
    // eslint-disable-next-line react/forbid-foreign-prop-types
    var _WrappedComponent$pro = WrappedComponent.propTypes,
        brand = _WrappedComponent$pro.brand,
        originalPropTypes = _objectWithoutProperties(_WrappedComponent$pro, ['brand']);

    WithBrand.propTypes = (0, _airbnbPropTypes.forbidExtraProps)(originalPropTypes);
  }

  if (WrappedComponent.defaultProps) {
    WithBrand.defaultProps = WrappedComponent.defaultProps;
  }

  var wrappedComponentName = (0, _getComponentName2['default'])(WrappedComponent) || 'Component';
  WithBrand.displayName = 'withBrand(' + String(wrappedComponentName) + ')';

  return (0, _hoistNonReactStatics2['default'])(WithBrand, WrappedComponent);
}


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/themes/withBrand.js
// module id = 76
// module chunks = 168707334958949